import Banner from '../components/Banner';
import ProductCard from '../components/ProductCard';
import ProductCardLandscape from '../components/ProductCardLandscape';
import SubscriptionModal from '../components/SubscriptionModal';
// import CategoryCard from '../components/CategoryCard';
import Footer from '../components/Footer';
import { getProducts } from '../data';

function Home() {
  let Products = getProducts();
  return (
    <div className="p-1 pt-4 w-full">
      <SubscriptionModal />
      <Banner />
      <section className="p-4 ">
        <div className="w-full lg:w-2/3 mx-auto gap-5 grid lg:grid-cols-3">
          <div className="transform hover:scale-110 transition duration-500 border flex gap-5 border-blue-400 p-3">
            <div>
              <svg
                className="w-12 h-12 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                ></path>
              </svg>
            </div>
            <div>
              <h2 className="text-lg font-bold">Free Shipping</h2>
              <h5 className="text-xs text-gray-600">Order over Ghc 200.00</h5>
            </div>
          </div>
          <div className="transform hover:scale-110 transition duration-500 border flex gap-5 border-blue-400 p-3">
            <div>
              <svg
                className="w-12 h-12 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                ></path>
              </svg>
            </div>
            <div>
              <h2 className="text-lg font-bold">Money Returns</h2>
              <h5 className="text-xs text-gray-600">30 Days money return</h5>
            </div>
          </div>
          <div className="transform hover:scale-110 transition duration-500 border flex gap-5 border-blue-400 p-3">
            <div>
              <svg
                className="w-12 h-12 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                ></path>
              </svg>
            </div>
            <div>
              <h2 className="text-lg font-bold">Free Shipping</h2>
              <h5 className="text-xs text-gray-600">Order over Ghc 200.00</h5>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container mx-auto">
          <div className="w-full py-5 mb-3">
            <div className="border-b lg:inline">
              <h2 className="text-xl border-b-2 p-2 border-blue-400 text-gray-900 font-bold w-1/2 inline uppercase">
                Featured Products
              </h2>
            </div>
            <div className="lg:float-right gap-2 ">
              <button className="border-t p-2 border-blue-400">Women</button>
              <button className="hover:border-t p-2 border-blue-400">
                Men
              </button>
              <button className="hover:border-t p-2 border-blue-400">
                Kids
              </button>
            </div>
          </div>
          <div className="grid bg-gray-100 lg:grid-cols-4 w-full gap-2 lg:gap-5">
            <div className="row-span-2 col-span-2">
            <ProductCard name="Arm Chair" price="20.00" img="imgs/arm-chair.jpg" w="full" h="40"/>
            </div>
            <div className="">
              <ProductCard name="Hoodie" price="20.00" img="imgs/hoddie.jpg"/>
            </div>
            <div className="">
              <ProductCard name="Shoes" price="60.00" img="imgs/shoes.jpg" />
            </div>
            <div className="">
              <ProductCard name="Hoodie" price="20.00" img="imgs/hoddie.jpg" />
            </div>
            <div className="">
              <ProductCard name="Shoes" price="60.00"  img="imgs/shoes.jpg"/>
            </div>
          </div>
        </div>
      </section>
      <div className="container py-10 mx-auto grid gap-3 grid-cols-1 lg:grid-cols-4">
        <div className="col-span-2  row-span-2">
          <img
            alt=""
            src="imgs/bn5.jpg"
            className="object-cover object-center w-full h-full "
          />
        </div>
        <div className="lg:col-span-2">
          <img
            alt=""
            src="imgs/bn6.jpg"
            className="object-contain object-center w-full "
          />
        </div>
        <div className="col-span-2">
          <img
            alt=""
            src="imgs/bn7.jpg"
            className="object-contain object-center w-full"
          />
        </div>
      </div>
      <div className="container mx-auto grid gap-2 lg:gap-10 lg:grid-cols-3">
        <div className="  ">
          <div className="p-2 border-t-2 rounded-t-lg border-blue-600 w-full">
            <div className="text-sm font-bold ">
              <h2 className="text-gray-700 inline-block">TOP SALE</h2>
              <div className=" flex float-right gap-2">
                <button className="bg-gray-900 pr-1 pl-1 rounded-full text-gray-100">
                  &lt;
                </button>
                <button className="bg-gray-900 pr-1 pl-1 rounded-full text-gray-100">
                  &gt;
                </button>
              </div>
            </div>
            <div className="mt-2">
              {Products.map((products) => (
                <ProductCardLandscape
                  name={products.name}
                  price={products.price}
                  cta="Buy Now"
                  flexed="flex"
                />
              ))}
            </div>
          </div>
        </div>
        <div className="">
          <div className="p-2 border-t-2 rounded-t-lg border-blue-600 w-full">
            <div className="text-sm font-bold">
              <h2 className="text-gray-700">NEW ARRIVALS </h2>
            </div>
            <div className="overflow-x-scroll ">
              {Products.map((products) => (
                <ProductCardLandscape
                  name={products.name}
                  price={products.price}
                  cta="Buy Now"
                  flexed="flex"
                />
              ))}
            </div>
          </div>
        </div>
        <div className=" ">
          <div className="p-2 border-t-2 rounded-t-lg border-blue-600 w-full">
            <div className="text-sm font-bold">
              <h2 className="text-gray-700">FEATURED </h2>
            </div>
            <div className="">
              {Products.map((products) => (
                <ProductCardLandscape
                  name={products.name}
                  price={products.price}
                  cta="Buy Now"
                  flexed="flex"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <section className="mb-24 container mx-auto">
        <div className="p-2 lg:p-24">
          <h2 className="text-xl text-gray-900 font-bold mb-4">LATEST DEALS</h2>
          <div className="grid lg:grid-cols-2 gap-2">
            <ProductCardLandscape
              name="Wrist watch"
              price="200"
              cta="Buy Now"
            />
            <ProductCardLandscape
              name="Wrist watch"
              price="200"
              cta="Buy Now"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;
